import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Form, Input } from 'reactstrap'
import { isLostPassOpen, submitLogin, resetPass, loginLoading } from '../../store/common'
import { RingLoader } from 'react-spinners'
import { getTranslate } from 'react-localize-redux'
import shop from "../../api/shop";

class LoginForm extends Component {
  constructor() {
    super();
    this.state = { isLoading: false, message: null };

    this.resetPass = this.resetPass.bind(this);
  }

  resetPass = (e, section) => {
    this.setState({
      isLoading: true,
      message: null
    });
    shop.forgottenPassword(
      { login: e.target.querySelector('#email').value },
      commonDataFromApi => {
        commonDataFromApi.then(data => {
          let msg = "Neúspešný reset hesla";
          if (data.success) {
            msg = "Nové heslo Vám bolo odoslané na váš email.";
          }
          this.setState({
            isLoading: false,
            message: msg
          });
        });
      },
      0
    );
  };

  render() {
    const {
      submitLogin,
      isLostPassOpen,
      changeInputValue,
      loginLoading,
      translate
    } = this.props;

    if (this.state.message && isLostPassOpen) return <React.Fragment>{this.state.message}</React.Fragment>;

    return (
      <Form
        onSubmit={e => {
          e.preventDefault()
          isLostPassOpen ? this.resetPass(e) : submitLogin(e)
        }}
      >

        <div className='d-flex flex-column'>
          <div className='d-flex form-row'>
            <div className='flex-fill d-flex align-items-stretch form-label'>
              <div className='align-self-center'>{translate('molecules.containers.loginForm.username')}</div>
            </div>
            <div className='flex-fill'>
              <Input
                type={'text'}
                name={'email'}
                id={'email'}
                placeholder={translate('molecules.containers.loginForm.username')}
                className={'form-input'}
                onChange={e => {
                  changeInputValue(e.target.value, 'form_email')
                  e.stopPropagation()
                }}
              />
            </div>
          </div>
          {!isLostPassOpen &&
            <div className='d-flex form-row'>
              <div className='flex-fill d-flex align-items-stretch form-label'>
                <div className='align-self-center'>{translate('molecules.containers.loginForm.password')}</div>
              </div>
              <div className='flex-fill'>
                <Input
                  type={'password'}
                  name={'password'}
                  id={'password'}
                  placeholder={translate('molecules.containers.loginForm.password')}
                  className={'form-input'}
                  onChange={e => {
                    changeInputValue(e.target.value, 'form_password')
                    e.stopPropagation()
                  }}
                />
              </div>
            </div>}
          <div className='d-flex justify-content-center'>
            <button type='submit' className='button-red block login-btn'>
              {!isLostPassOpen ? (!loginLoading && translate('molecules.containers.loginForm.login')) : translate('molecules.containers.loginForm.reset')}
              <RingLoader color={'#fff'} loading={loginLoading || this.state.isLoading} size={20} />
            </button>
          </div>
        </div>
      </Form>
    )
  }
}

LoginForm.propTypes = {
  submitLogin: PropTypes.func,
  resetPass: PropTypes.func,
  isLostPassOpen: PropTypes.bool,
  changeInputValue: PropTypes.func,
  loginLoading: PropTypes.bool,
  translate: PropTypes.func
}

const mapStateToProps = ({ common, locale }) => ({
  translate: getTranslate(locale),
  isLostPassOpen: isLostPassOpen(common.lostPassOpen),
  loginLoading: common.loginLoading
})

const mapDispatchToProps = dispatch => ({
  submitLogin: e => {
    dispatch(loginLoading(true))
    dispatch(
      submitLogin(
        e.target.querySelector('#email').value,
        e.target.querySelector('#password').value
      )
    )
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(LoginForm)



// WEBPACK FOOTER //
// ./src/molecules/containers/LoginForm.js